import * as React from "react";
import { SVGProps, memo } from "react";

const SvgMapPin = (props: SVGProps<SVGSVGElement>) => (
  <svg width={56} height={69} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#MapPin_svg__a)">
      <mask id="MapPin_svg__b" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.145 46.919C44.91 43.877 52 34.767 52 24 52 10.745 41.255 0 28 0S4 10.745 4 24c0 10.766 7.089 19.876 16.854 22.918l7.145 12.377 7.146-12.377Z"
        />
      </mask>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.145 46.919C44.91 43.877 52 34.767 52 24 52 10.745 41.255 0 28 0S4 10.745 4 24c0 10.766 7.089 19.876 16.854 22.918l7.145 12.377 7.146-12.377Z"
        fill="#2BA168"
      />

      <path
        d="m35.145 46.919-.595-1.91-.746.232-.391.678 1.732 1Zm-14.291-.001 1.732-1-.391-.677-.747-.233-.594 1.91Zm7.145 12.377-1.732 1 1.732 3 1.733-3-1.733-1ZM50 24c0 9.866-6.496 18.22-15.45 21.009l1.19 3.819C46.317 45.534 54 35.667 54 24h-4ZM28 2c12.15 0 22 9.85 22 22h4C54 9.64 42.36-2 28-2v4ZM6 24C6 11.85 15.85 2 28 2v-4C13.64-2 2 9.64 2 24h4Zm15.448 21.008C12.496 42.22 6 33.867 6 24H2c0 11.666 7.682 21.533 18.259 24.828l1.19-3.82Zm8.284 13.287-7.146-12.377-3.464 2 7.145 12.377 3.465-2Zm3.681-12.377-7.146 12.377 3.465 2 7.145-12.377-3.464-2Z"
        fill="#fff"
        mask="url(#MapPin_svg__b)"
      />

      <path
        d="M33.136 13.909c-1.7 0-3.264.578-4.511 1.547a2.208 2.208 0 0 0-.767-.14c-.25 0-.491.045-.716.12a7.358 7.358 0 0 0-9.671 11.053l5.206 5.207 5.204 5.204.016-.016.016.016 5.203-5.204 5.207-5.206a7.397 7.397 0 0 0 2.174-5.222 7.36 7.36 0 0 0-7.36-7.36Zm3.43 10.826L31.36 29.94l-3.463 3.463-3.464-3.464-1.329-1.33a7.307 7.307 0 0 0 4.04-1.514 2.208 2.208 0 1 0-1.494-2.087c0 .034.004.066.006.099a4.875 4.875 0 1 1 .001-7.681c-.001.032-.005.064-.005.097a2.208 2.208 0 0 0 4.415 0 .418.418 0 0 0-.003-.041 4.875 4.875 0 0 1 7.948 3.785 4.918 4.918 0 0 1-1.446 3.467Z"
        fill="#fff"
      />
    </g>

    <defs>
      <filter
        id="MapPin_svg__a"
        x={0}
        y={0}
        width={56}
        height={69}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />

        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />

        <feOffset dy={5} />

        <feGaussianBlur stdDeviation={2} />

        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />

        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3421_20540" />

        <feBlend in="SourceGraphic" in2="effect1_dropShadow_3421_20540" result="shape" />
      </filter>
    </defs>
  </svg>
);

const Memo = memo(SvgMapPin);

export default Memo;
